import { useRouter } from 'next/router';
import { cookieHelper } from 'src/utils/cookieHelper';
import { useEffect } from 'react';
import useFacebookAnalyticsStore from './useFacebookAnalyticsStore';

export const useFacebookAnalyticsHooks = () => {
  const { query } = useRouter();

  const setAnalyticsTokens = useFacebookAnalyticsStore(
    (state) => state.setAnalyticsTokens
  );
  const fbclid = useFacebookAnalyticsStore((state) => state.fbclid);
  const fbp = useFacebookAnalyticsStore((state) => state.fbp);

  useEffect(() => {
    if (!fbclid && !fbp && setAnalyticsTokens) {
      const newFbclid =
        cookieHelper.getCookie('_fbc') ?? (query?.fbclid as string);
      const newFbp = cookieHelper.getCookie('_fbp');
      setAnalyticsTokens({
        fbclid: newFbclid,
        fbp: newFbp
      });
    }
  }, [setAnalyticsTokens, fbclid, fbp, query?.fbclid]);
};
